import packageInfo from '@/../package.json'

export default {
  name: 'Delivery In Box',
  version: packageInfo.version,
}
